export function initAccordions(root = document) {
    const buttons = root.querySelectorAll('.accordion button:not([data-accordion-bound])');

    buttons.forEach((button) => {
        button.dataset.accordionBound = 'true';

        button.addEventListener("click", function () {
            const panel = document.getElementById(this.getAttribute("aria-controls"));
            const isOpen = this.getAttribute("aria-expanded") === "true";

            if (isOpen) {
                this.setAttribute("aria-expanded", "false");
                if (panel) panel.setAttribute('aria-hidden', 'true');
            } else {
                // Close all panels
                buttons.forEach((btn) => {
                    btn.setAttribute("aria-expanded", "false");
                    const currentPanel = document.getElementById(btn.getAttribute("aria-controls"));
                    if (currentPanel) currentPanel.setAttribute('aria-hidden', 'true');
                });
                // Open the clicked panel
                this.setAttribute("aria-expanded", "true");
                if (panel) panel.setAttribute('aria-hidden', 'false');
            }
        });
    });

    // Product Details Accordion
    root.querySelectorAll('.pd-accordion .pd-accordion-header:not([data-pda-bound])').forEach(function (btn) {
        btn.dataset.pdaBound = 'true';

        btn.addEventListener("click", function () {
            var item = this.closest(".pd-accordion-item");
            var panel = document.getElementById(this.getAttribute("aria-controls"));
            var isOpen = this.getAttribute("aria-expanded") === "true";

            if (isOpen) {
                item.classList.remove("is-open");
                this.setAttribute("aria-expanded", "false");
                if (panel) panel.setAttribute("aria-hidden", "true");
            } else {
                item.classList.add("is-open");
                this.setAttribute("aria-expanded", "true");
                if (panel) panel.setAttribute("aria-hidden", "false");
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initAccordions();
    });
} else {
    initAccordions();
}
